import { ApiAdpTableContent, ApiAdpTableRow, ApiComponentAdpTable } from 'data-source/types.wp'
import { DSNCSpecTable, DSSpecItem, DSSpecRow } from 'shared-definitions/types'
import { pLinkExternalMapper } from './pLinkMapper'

export function ncSpecTable(input: ApiComponentAdpTable): DSNCSpecTable {
  return {
    resource: 'nc-spec-table',
    title: input.name,
    rows: input.data.map(mapRow),
    collapsedRows: input.collapsible ? input.collapsed_data?.map(mapRow) ?? null : null,
    pLinkEdit: input.edit_url ? pLinkExternalMapper(input.edit_url) : null,
    pLinkRequestUpdate: input.update_request_url
      ? pLinkExternalMapper(input.update_request_url)
      : null,
    labels: {
      expand: input.expand_button_title,
      collapse: input.collapse_button_title,
    },
  }
}

function mapRow(input: ApiAdpTableRow): DSSpecRow {
  return {
    cells: input.content.map(i => ({
      content: mapItemContent(i.content),
    })),
  }
}

function mapItemContent(input: string | ApiAdpTableContent[]): DSSpecItem[] {
  if (typeof input === 'string') {
    return [
      {
        type: 'string',
        content: input,
      },
    ]
  }

  return input.map(mapBlock)
}

function mapBlock(input: ApiAdpTableContent): DSSpecItem {
  if (typeof input === 'string') {
    return {
      type: 'string',
      content: input,
    }
  }

  if (input.type === 'string') {
    return {
      type: 'string',
      content: input.content,
    }
  }

  if (input.type === 'block') {
    return {
      type: 'block',
      content: mapItemContent(input.content),
    }
  }

  return {
    type: 'list',
    content: input.content.map(i => ({
      type: 'list-item',
      content: mapItemContent(i.content),
    })),
  }
}
